import React, { useCallback } from 'react';
import { LocationDTO } from '@peartherapeutics/weaver-api-client';

import CircularLoader from 'components/common/CircularLoader';
import TableHeader from './TableHeader';
import Row from './Row';

export interface IOwnProps {
  locations: LocationDTO[];
  isLoaded: boolean;
  sortProp: Nullable<string>;
  sortOrder: Nullable<string>;
  sortBy: (prop: string) => void;
  isLocationWrite: boolean;
}

export const LocationsTable = (props: IOwnProps) => {
  const { locations, isLoaded, sortProp, sortOrder, sortBy, isLocationWrite } =
    props;

  const renderLoader = useCallback(
    () => (
      <tr>
        <td colSpan={isLocationWrite ? 7 : 6}>
          <CircularLoader />
        </td>
      </tr>
    ),
    [isLocationWrite],
  );

  const renderData = useCallback(() => {
    return locations.length ? (
      locations.map((location) => (
        <Row
          key={location.id}
          location={location}
          isLocationWrite={isLocationWrite}
        />
      ))
    ) : (
      <tr>
        <td colSpan={isLocationWrite ? 7 : 6}>
          <div>No Result Found</div>
        </td>
      </tr>
    );
  }, [isLocationWrite, locations]);

  const renderTableRows = useCallback(
    () => (isLoaded ? renderData() : renderLoader()),
    [isLoaded, renderData, renderLoader],
  );

  return (
    <table data-testid="locations-table">
      <TableHeader
        sortProp={sortProp}
        sortOrder={sortOrder}
        sortBy={sortBy}
        isLocationWrite={isLocationWrite}
      />
      <tbody>{renderTableRows()}</tbody>
    </table>
  );
};

export default LocationsTable;
